/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TransactionCell_transaction$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FastCashContainer_fastCashLists$ref: FragmentReference;
declare export opaque type FastCashContainer_fastCashLists$fragmentType: FastCashContainer_fastCashLists$ref;
export type FastCashContainer_fastCashLists = {|
  +id: string,
  +plaidTransactions: {|
    +pageInfo: {|
      +hasNextPage: boolean,
      +endCursor: ?string,
    |},
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +state: ?string,
        +date: ?string,
        +$fragmentRefs: TransactionCell_transaction$ref,
      |}
    |}>,
  |},
  +$refType: FastCashContainer_fastCashLists$ref,
|};
export type FastCashContainer_fastCashLists$data = FastCashContainer_fastCashLists;
export type FastCashContainer_fastCashLists$key = {
  +$data?: FastCashContainer_fastCashLists$data,
  +$fragmentRefs: FastCashContainer_fastCashLists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "byAuth0Id",
      "type": "String!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "afterDate",
      "type": "Date!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "beforeDate",
      "type": "Date!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order",
      "type": "String!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "bankAccountIdEq",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "stateEq",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "storeIdEq",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "integrationItemIdEq",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "nameCont",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "byMerchantNames",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "nameNotIContAll",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "plaidTransactions"
        ]
      }
    ]
  },
  "name": "FastCashContainer_fastCashLists",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "plaidTransactions",
      "args": [
        {
          "kind": "Variable",
          "name": "afterDate",
          "variableName": "afterDate"
        },
        {
          "kind": "Variable",
          "name": "bankAccountIdEq",
          "variableName": "bankAccountIdEq"
        },
        {
          "kind": "Variable",
          "name": "beforeDate",
          "variableName": "beforeDate"
        },
        {
          "kind": "Variable",
          "name": "byAuth0Id",
          "variableName": "byAuth0Id"
        },
        {
          "kind": "Variable",
          "name": "byMerchantNames",
          "variableName": "byMerchantNames"
        },
        {
          "kind": "Variable",
          "name": "integrationItemIdEq",
          "variableName": "integrationItemIdEq"
        },
        {
          "kind": "Variable",
          "name": "nameCont",
          "variableName": "nameCont"
        },
        {
          "kind": "Variable",
          "name": "nameNotIContAll",
          "variableName": "nameNotIContAll"
        },
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        },
        {
          "kind": "Variable",
          "name": "stateEq",
          "variableName": "stateEq"
        },
        {
          "kind": "Variable",
          "name": "storeIdEq",
          "variableName": "storeIdEq"
        }
      ],
      "concreteType": "PlaidTransactionConnection",
      "kind": "LinkedField",
      "name": "__FastCashContainer_plaidTransactions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PlaidTransactionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PlaidTransaction",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TransactionCell_transaction"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FastCashLists"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a37328aad674693c9e497b3c572eb392';

module.exports = node;
